<template>
  <div class="w-full h-screen flex flex-col bg-surface-50">
    <Toolbar>
      <template #start>
        <div class="flex flex-row items-center gap-6">
          <RouterLink to="/">
            <img src="/images/phottr-logo.webp" alt="Phottr logo" class="h-12" />
          </RouterLink>
          <RouterLink to="/" active-class="text-primary-500 font-bold">Products</RouterLink>
          <RouterLink to="/usage" active-class="text-primary-500 font-bold">Usage</RouterLink>
          <RouterLink
            v-if="!organization?.personal"
            to="/users"
            active-class="text-primary-500 font-bold"
            >Users</RouterLink
          >
          <RouterLink
            v-if="!organization?.personal"
            to="/api-settings"
            active-class="text-primary-500 font-bold"
            >API</RouterLink
          >
        </div>
      </template>
      <template #end> <UserMenu /> </template>
    </Toolbar>
    <div class="flex-1 overflow-auto">
      <div class="p-2">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '@/modules/auth/auth';
import UserMenu from '@/modules/auth/UserMenu.vue';
import Toolbar from 'primevue/toolbar';
import { RouterLink } from 'vue-router';

const { organization } = useAuth();
</script>
